/*
 * AppContext - Zentraler Anwendungskontext
 *
 * Hält alle Singleton-Referenzen und globalen Flags.
 * Wird in init() befüllt und von allen Modulen per Import gelesen/geschrieben.
 */

export const ctx = {
    // === Singleton-Referenzen ===
    screen: null,
    cursor: null,
    renderer: null,
    overlay: null,
    menu: null,
    layout: null,
    editor: null,
    metadata: null,
    fileManager: null,
    dialogManager: null,
    searchManager: null,
    soundManager: null,
    coreConsole: null,
    dictationManager: null,
    contextMenu: null,

    // === Auth & Cloud ===
    authService: null,
    user: null,           // { id, email, name, avatarUrl, role }
    syncService: null,
    userMenu: null,

    // === Projekt-Management ===
    projectManager: null,
    currentProjectId: null,
    tabManager: null,
    tabBarRenderer: null,
    projectDashboard: null,

    // === Flags ===
    isRunning: false,
    _overlayConsumedMouseDown: false,

    // === Tab-Doppelklick-Erkennung ===
    lastTabTime: 0,
    layoutNavigationMode: false,
    previousActivePane: null,

    // === Debounce ===
    saveContentTimeout: null,
    _settingsDirty: false,

    // === Uhr-Update ===
    lastClockMinute: -1,

    // === Such-Navigation ===
    _searchHistoryFromPos: null
}
